// Texto 12 C (My Planner Web): enquanto o app está aberto no computador,
//  · confere a cada minuto (e ao voltar para a aba do navegador) se este computador ainda é o conectado da conta;
//    se foi desconectado pelo celular ou trocado por outro computador, sai sozinho e avisa;
//  · bloqueia depois de um tempo parado (5, 15 ou 30 minutos; padrão 15), por causa do Diário e do Prontuário.
//    Para voltar: a senha da conta (ou entrar com o QR Code de novo).
import { useEffect, useRef } from 'react';
import { Alert, Platform } from 'react-native';
import { useAuth } from '../auth/AuthContext';
import { aindaConectado, aoMudarBloqueio, tempoBloqueio } from '../lib/computador';
import { DEMO } from '../lib/env';
import { t } from '../lib/i18n';

export function ComputadorWeb() {
  const a = useAuth();
  const ref = useRef(a); ref.current = a;
  const ultimo = useRef(Date.now());
  const minutos = useRef(15);

  // desconectado em outro lugar?
  useEffect(() => {
    if (Platform.OS !== 'web' || DEMO || a.status !== 'unlocked') return;
    let vivo = true;
    const conferir = async () => {
      if (!vivo || ref.current.status !== 'unlocked') return;
      if (await aindaConectado()) return;
      vivo = false;
      await ref.current.signOut(true);
      Alert.alert(t('Computador desconectado'), t('Este computador foi desconectado (pelo celular ou porque outro computador entrou). Para usar de novo, entre com o QR Code.'));
    };
    const iv = setInterval(conferir, 60_000);
    const vis = () => { if (document.visibilityState === 'visible') conferir(); };
    document.addEventListener('visibilitychange', vis);
    return () => { vivo = false; clearInterval(iv); document.removeEventListener('visibilitychange', vis); };
  }, [a.status]);

  // bloqueio por tempo parado
  useEffect(() => {
    if (Platform.OS !== 'web' || DEMO || a.status !== 'unlocked') return;
    tempoBloqueio().then(m => { minutos.current = m; });
    const sai = aoMudarBloqueio(m => { minutos.current = m; ultimo.current = Date.now(); });
    ultimo.current = Date.now();
    const mexeu = () => { ultimo.current = Date.now(); };
    const eventos = ['mousemove', 'mousedown', 'keydown', 'wheel', 'touchstart', 'scroll'];
    eventos.forEach(e => window.addEventListener(e, mexeu, { passive: true, capture: true }));
    const iv = setInterval(() => {
      if (Date.now() - ultimo.current > minutos.current * 60_000) ref.current.lock();
    }, 15_000);
    return () => { sai(); clearInterval(iv); eventos.forEach(e => window.removeEventListener(e, mexeu, { capture: true } as any)); };
  }, [a.status]);

  return null;
}
